<template>
  <form
    class="simple-update-form"
    @submit.prevent="submitForm"
  >
    <div
      class="row bottom-xs"
      v-if="!updatePassword"
    >
      <div class="col-xs-12 col-md-4 col-lg-3">
        <BaseFormField label="Status">
          <BaseSelect
            label="name"
            :placeholder="form.isAdministrator | IsAdmin"
            @select="updateDeleted"
            :options="[{value: true, name: 'Administrator'}, {value: false, name: 'Bruger'}]"
            :disabled="loading"
          />
        </BaseFormField>
      </div>
      <div class="col-xs-12 col-md-5 col-lg-6">
        <BaseInput
          label="E-mail"
          v-model="form.email"
        />
      </div>
      <div class="col-xs-12 col-md-3">
        <BaseButton
          full
          label="Gem ændringer"
          :disabled="loading || $v.$invalid"
        />
      </div>
    </div>
    <div
      class="row bottom-xs"
      v-if="updatePassword"
    >
      <div class="col-xs-6 col-md-3">
        <BaseInput
          class="user-update-password"
          placeholder="Udfyld kun hvis det skal ændres"
          label="Nyt kodeord"
          type="password"
          v-model="newPassword"
        />
      </div>
      <div class="col-xs-12 col-md-offset-6 col-md-3">
        <BaseButton
          full
          label="Gem ændringer"
          :disabled="loading || $v.$invalid"
        />
      </div>
    </div>
    <div
      class="simple-update-form__loading"
      v-if="loading"
    >
      <BaseSpinner
        height="40px"
        width="40px"
      />
    </div>
  </form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import BaseInput from '../../BaseInput.vue';
import BaseSelect from '../../BaseSelect.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import IsAdmin from '../../../filters/IsAdmin';
import UserService from '../../../services/UserService';


export default {
    name: 'UpdateUserForm',
    components: {
        BaseButton, BaseSpinner, BaseFormField, BaseSelect, BaseInput,
    },
    filters: { IsAdmin },
    props: {
        form: { type: Object, required: true },
        updatePassword: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: false,
            newPassword: '',
        };
    },
    validations() {
        if (this.updatePassword) {
            return {
                newPassword: { required },
            };
        }

        return {
            form: {
                email: { required, email },
            },
        };
    },
    methods: {
        updateDeleted(e) {
            this.form.isAdministrator = e.value;
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snotify.error('Navn eller link er ikke udfyldt korrekt.');
                return;
            }

            try {
                this.loading = true;

                const formatRequest = this.form;
                if (this.updatePassword && this.newPassword) {
                    formatRequest.password = this.newPassword;
                }

                const payload = await UserService.update(formatRequest);

                this.$snotify.success(`${payload.email} er opdateret`);
                this.loading = false;
                this.newPassword = '';
            } catch (error) {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.simple-update-form {
    margin-top: 20px;
    background-color: $white2;
    padding: 10px;
    border-radius: 5px;
    position: relative;

    &__loading {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
}
</style>
